import {useState} from 'react'
import {useMaintenanceQuery} from "./hooks/useMaintenanceQuery.js"
import moment from "moment"
import Button from "../../common/components/Button.jsx"
import XLSX from "sheetjs-style"
import {saveFile} from "../../common/utils/saveFile.util.js"

function RelationPreventiveMaintenance(){
  const [filters] = useState({
    startDate: '',
    endDate: moment().format('YYYY-MM-DD'),
    type: "preventivo",
    page: null,
    limit: null,
  })
  const {maintenances} = useMaintenanceQuery(filters)

  const exportData = () => {
    const dataToExport = maintenances.map((maintenance) => ({
     FECHA: moment(maintenance.date).format("DD/MM/YYYY"),
     PLACA: maintenance.plate,
      TIPO: maintenance.type,
      "NOMBRE RESPONSABLE": maintenance.nameManager,
      "IDENTIFICACIÓN RESPONSABLE": maintenance.identificationManager,
      "ROL RESPONSABLE": maintenance.roleManager,
      "NIT ESTABLECIMIENTO": maintenance.nitCompany,
      "DIRECCIÓN ESTABLECIMIENTO": maintenance.addressCompany,
    }))

    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
      const file = new Blob([excelBuffer], { type: fileType });
      const filename = `Relacion-mantenimientos-${moment().format(
        "DD-MM-YYYY",
      )}_${moment().unix()}.xlsx`;
      saveFile(file, filename);

  }

  return(
    <main className="container">
      <header>
        <h1>Relación mantenimientos preventivos</h1>
      </header>
      <section>
        <Button onClick={exportData}>Exportar información</Button>
      </section>
    </main>
  )
}

export default RelationPreventiveMaintenance
